import React, { FC, useContext } from "react";
import { Link } from "react-router-dom";
import { AdequacyFilterSection } from "@app/projects/network-assessment/multi-map-export/components/AdequacyFilterSection";
import { BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";
import { MapContentSection } from "@app/projects/network-assessment/multi-map-export/components/MapContentSection";
import { MapExportSample } from "@app/projects/network-assessment/multi-map-export/components/MapExportSample";
import { MapStyleSection } from "@app/projects/network-assessment/multi-map-export/components/MapStyleSection";
import { MapCountSection } from "@app/projects/network-assessment/multi-map-export/components/MapCountSection";
import { MapTypeSection } from "@app/projects/network-assessment/multi-map-export/components/MapTypeSection";
import { OutputSection } from "@app/projects/network-assessment/multi-map-export/components/OutputSection";
import { ServiceAreaSection } from "@app/projects/network-assessment/multi-map-export/components/ServiceAreaSection";
import { SpecialtySection } from "@app/projects/network-assessment/multi-map-export/components/SpecialtySection";
import { MultiMapExportContext } from "@app/projects/network-assessment/multi-map-export/MultiMapExportContext";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import PageInner from "@app/shared/PageInner";

export const MultiMapExportPage: FC<React.PropsWithChildren<unknown>> = () => {
  const { project } = useContext(MultiMapExportContext);
  const projectName = project?.resource.name || "";

  return (
    <Page documentTitle="Create Multiple Maps">
      <Breadcrumbs template={BreadcrumbTemplateEnum.NetworkAssessment} items={[projectName]} />
      <PageInner className="multi-map-export">
        <PageHeader title="Create Multiple Maps" disableHR={true}>
          <PageHeaderRight>
            <Link
              className="qes-button qes-button-secondary"
              data-testid="multi-map-export__return-to-project"
              to={`/projects/${project?.projectId}/mapping`}
            >
              Return to Project
            </Link>
          </PageHeaderRight>
        </PageHeader>
        <p className="multi-map-export__subtitle" data-testid="multi-map-export__subtitle">Create a .zip file of multiple maps at once from a set of criteria.</p>
        <div className="multi-map-export__layout">
          <div className="multi-map-export__config-column">
            <MapTypeSection />
            <ServiceAreaSection />
            <SpecialtySection />
            <AdequacyFilterSection />
            <MapContentSection />
            <MapStyleSection />
          </div>
          <aside className="multi-map-export__right-rail" data-testid="multi-map-export__right-rail">
            <MapCountSection />
            <MapExportSample />
            <OutputSection />
          </aside>
        </div>
      </PageInner>
    </Page>
  );
};

export default MultiMapExportPage;
